export default __webpack_public_path__ + "static/media/baunebakken-property-06.f934960c.jpg";